export const UNDERSCORE = '───';
export const DASHES = '---';
export const HYPHEN = '-';
export const PERCENTAGE = '%';
export const EMPTYSPACE = ' ';
export const ARCELOR_SUPPLIER_DESC = 'ArcelorMittal Europe - Flat Products';

export enum OrderByDirection {
	DESC = 'desc', ASC = 'asc'
}

export class OrderBy<T extends string> {
	constructor(
		public field: T,
		public direction: OrderByDirection
	) {}

	toString() {
		return `${ String(this.field) } ${ this.direction }`;
	}
}
